import { SettingsRoutes } from '@frontend/settings-routing';

export const insuranceSettingsPageRoutes: Record<string, SettingsRoutes> = {
  automaticVerificationSettings: '/insurance/automatic-verification',
  automaticVerificationSettingsWithLocation: '/insurance/automatic-verification/:locationId',
  payerConnectionManagement: '/insurance/payer-connection-management',
  payerConnectionManagementWithLocation: '/insurance/payer-connection-management/:locationId',
  cdtCodeManagement: '/insurance/cdt-code-management',
  cdtCodeManagementWithLocation: '/insurance/cdt-code-management/:locationId',
};
